import { baseApi } from "@/redux/api/baseApi";

const videoScriptApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVideoScript: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/video-script/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["videoScript"],
    }),
    getFinalVideoScript: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/video-script/get-final-script/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["videoScript"],
    }),
    requestScriptRevision: builder.mutation({
      query: (payload) => ({
        url: `/video-script/request-revision/${payload.orderId}/${payload.videoId}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["videoScript"],
    }),
    approveScript: builder.mutation({
      query: (payload) => ({
        url: `/video-script/approve-script/${payload.orderId}/${payload.videoId}`,
        method: "POST",
      }),
      invalidatesTags: ["videoScript","OrderDetails"],
    }),
    uploadScript: builder.mutation({
      query: (payload) => ({
        url: `/video-script/upload-new-script/${payload.orderId}/${payload.videoId}`,
        method: 'POST',
        body: payload?.data,
      }),
      invalidatesTags: ["videoScript","OrderDetails"], // Invalidate tag on success
    }),
    requestTimeLineExtension: builder.mutation({
      query: ({ orderId, videoId, body }) => ({
        url: `/video-script/request-an-extension/${orderId}/${videoId}`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["videoScript"],
    }),
  }),
});

export const {
  useRequestScriptRevisionMutation,
  useGetVideoScriptQuery,
  useApproveScriptMutation,
  useRequestTimeLineExtensionMutation,
  useUploadScriptMutation,
  useGetFinalVideoScriptQuery
} = videoScriptApi;
